/* NZS nav skeleton — page-type-aware wireframe overlay shown during full-page navigation.
   Server-rendered theme: the old page stays on screen during the click->response gap, so we
   deliberately overlay a destination-shaped skeleton (cleared automatically when the new doc loads).
   Vanilla, no deps. Loaded with `defer` from layout/theme.liquid. Kill switch: window.__nzsNavSkOff=true. */
(function(){
  if (window.Shopify && Shopify.designMode) return;   // theme editor: never obscure the canvas
  if (window.__nzsNavSkOff) return;                    // global kill switch
  if (window.__nzsNavSk) return; window.__nzsNavSk = 1;

  var DELAY = 150, SAFETY = 8000, t = null, el = null;
  function fill(n, s){ var o = ''; while (n-- > 0) o += s; return o; }

  var TPL = {
    pdp:  '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-gal"></div>'+
            '<div class="nzs-sk-col">'+
              '<div class="nzs-sk nzs-sk-bar"></div>'+
              '<div class="nzs-sk nzs-sk-bar"></div>'+
              '<div class="nzs-sk nzs-sk-bar nzs-sk--w80"></div>'+
              '<div class="nzs-sk nzs-sk-btn"></div>'+
            '</div>'+
          '</div>',
    coll: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-fil"></div>'+
            '<div class="nzs-sk-grid">'+ fill(6, '<div class="nzs-sk nzs-sk-card"></div>') +'</div>'+
          '</div>',
    art:  '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-bar"></div>'+ fill(7, '<div class="nzs-sk nzs-sk-bar nzs-sk--w80"></div>') +
          '</div>',
    cart: '<div class="nzs-nav-sk__wrap">'+ fill(3, '<div class="nzs-sk nzs-sk-line"></div>') +'</div>',
    account: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-bar nzs-sk--w80"></div>'+
            fill(4, '<div class="nzs-sk nzs-sk-line"></div>') +
            '<div class="nzs-sk nzs-sk-btn"></div>'+
          '</div>',
    review: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-bar nzs-sk--w50"></div>'+
            '<div class="nzs-sk-rev">'+
              '<div class="nzs-sk-rev__lines">'+ fill(5, '<div class="nzs-sk nzs-sk-line"></div>') +'</div>'+
              '<div class="nzs-sk nzs-sk-sum"></div>'+
            '</div>'+
          '</div>',
    home: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk" style="height:clamp(220px,38vh,380px);margin-bottom:26px"></div>'+
            '<div class="nzs-sk-grid" style="display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:18px">'+ fill(4, '<div class="nzs-sk nzs-sk-card"></div>') +'</div>'+
          '</div>',
    /* NZS-COMPARE-SK: /pages/compare -- heading, lead, tab pills, toolbar, card grid */
    compare: '<div class="nzs-nav-sk__wrap">'+
            '<div class="nzs-sk nzs-sk-cmp-h1"></div>'+
            '<div class="nzs-sk nzs-sk-cmp-lead"></div>'+
            '<div class="nzs-sk nzs-sk-cmp-lead nzs-sk-cmp-lead--short"></div>'+
            '<div class="nzs-sk-cmp-tabs">'+ fill(8, '<div class="nzs-sk nzs-sk-cmp-tab"></div>') +'</div>'+
            '<div class="nzs-sk-cmp-bar"><div class="nzs-sk nzs-sk-cmp-fil"></div><div class="nzs-sk nzs-sk-cmp-sort"></div></div>'+
            '<div class="nzs-sk-grid nzs-sk-cmp-grid">'+ fill(8, '<div class="nzs-sk nzs-sk-card"></div>') +'</div>'+
          '</div>',
    bar:  ''                                            // unmatched: top progress bar only
  };

  function kind(p){
    if (p === '/')                      return 'home';
    if (/\/products\//.test(p))         return 'pdp';   // /products/ ANYWHERE incl. /collections/x/products/y (was ^-anchored, so PDPs opened from a collection showed the collection skeleton)
    if (/^\/collections\//.test(p))     return 'coll';
    if (/^\/pages\/your-stack(\/|$)/.test(p)) return 'review';
    if (/^\/pages\/compare(\/|$)/.test(p)) return 'compare';   // NZS-COMPARE-SK: before the generic art match
    if (/^\/(pages|blogs)\//.test(p))   return 'art';
    if (p === '/cart')                  return 'cart';
    if (/^\/account(\/|$)/.test(p))     return 'account';
    return 'bar';                                       // search, anything else
  }

  function show(k){
    if (el) return;                                     // never stack overlays
    el = document.createElement('div');
    el.className = 'nzs-nav-sk nzs-nav-sk--' + k;
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="nzs-nav-sk__bar"></span>' + (TPL[k] || '');
    document.body.appendChild(el);
    try{ sessionStorage.setItem('nzsSkNav', el.outerHTML); }catch(_){}
    setTimeout(hide, SAFETY);                           // safety: nav cancelled / beforeunload prompt
  }
  function hide(){
    try{ sessionStorage.removeItem('nzsSkNav'); }catch(_){}
    if (el && el.parentNode) el.parentNode.removeChild(el);
    el = null;
    if (t){ clearTimeout(t); t = null; }
  }

  document.addEventListener('click', function(e){
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a');
    if (!a) return;
    if (a.target && a.target !== '_self') return;       // opens new tab/frame
    if (a.hasAttribute('download') || a.hasAttribute('data-no-skeleton')) return;
    if (a.closest('[data-no-skeleton]')) return;
    var href = a.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|sms:|javascript:)/i.test(href)) return;
    var u; try { u = new URL(a.href, location.href); } catch (_){ return; }
    if (u.origin !== location.origin) return;                                   // cross-origin
    if (u.pathname === location.pathname && u.search === location.search) return; // same page / hash jump
    if (/\/checkout(\/|$)/.test(u.pathname)) return;                            // checkout only (account shows the skeleton)
    var dest = kind(u.pathname);
    // Fire after a short delay so fast loads never flash; at fire-time re-check defaultPrevented so
    // client-intercepted links (filters, swatches, quick-view, cart toggle — all call preventDefault
    // in the bubble phase, after this capture handler) never leave a stuck overlay.
    t = setTimeout(function(){ if (!e.defaultPrevented) show(dest); }, DELAY);
  }, true);

  window.addEventListener('pageshow', function(ev){ if (ev.persisted) hide(); }); // bfcache Back
  window.addEventListener('popstate', hide);
})();
